import React, { JSX, useState } from 'react';
import { Styles } from './styles';
import { Menu } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';
import { useUserStore } from '@stores/User/User';

interface NavbarProps {
  isAuthenticated?: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ isAuthenticated = false }) => {
  const { user, token } = useUserStore();
  const [searchTerm, setSearchTerm] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleSearch = () => {
    if (searchTerm.trim()) {
      navigate(`/pesquisar?termo=${encodeURIComponent(searchTerm)}`);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const renderAgentMenuItems = (): JSX.Element => (
    <>
      <Styles.NavbarSection>
        <Styles.NavbarSectionTitle>IMÓVEIS</Styles.NavbarSectionTitle>
        <Styles.NavbarItem>
          <Styles.NavbarLink href="/area-do-corretor/imoveis/listagem">
            Listagem
          </Styles.NavbarLink>
        </Styles.NavbarItem>
        <Styles.NavbarItem>
          <Styles.NavbarLink href="/area-do-corretor/imoveis/novo-cadastro">
            Novo Cadastro
          </Styles.NavbarLink>
        </Styles.NavbarItem>
        <Styles.NavbarItem>
          <Styles.NavbarLink href="/area-do-corretor/imoveis/adicionar-codigo">
            Adicionar Código
          </Styles.NavbarLink>
        </Styles.NavbarItem>
      </Styles.NavbarSection>
      <Styles.NavbarSection>
        <Styles.NavbarSectionTitle>CLIENTES</Styles.NavbarSectionTitle>
        <Styles.NavbarItem>
          <Styles.NavbarLink href="/area-do-corretor/clientes/contato">
            Contatos via Site
          </Styles.NavbarLink>
        </Styles.NavbarItem>
        <Styles.NavbarItem>
          <Styles.NavbarLink href="/area-do-corretor/clientes/cadastre-seu-imovel">
            Cadastre seu imóvel
          </Styles.NavbarLink>
        </Styles.NavbarItem>
        <Styles.NavbarItem>
          <Styles.NavbarLink href="/area-do-corretor/clientes/encomende-seu-imovel">
            Encomende seu imóvel
          </Styles.NavbarLink>
        </Styles.NavbarItem>
      </Styles.NavbarSection>
      <Styles.NavbarSection>
        <Styles.NavbarSectionTitle>USUÁRIOS</Styles.NavbarSectionTitle>
        <Styles.NavbarItem>
          <Styles.NavbarLink href="/area-do-corretor/usuarios/listagem">
            Listagem
          </Styles.NavbarLink>
        </Styles.NavbarItem>
      </Styles.NavbarSection>
    </>
  );

  const renderMainMenuItems = (): JSX.Element => (
    <>
      <Styles.NavbarItem>
        <Styles.NavbarLink href="/home">Home</Styles.NavbarLink>
      </Styles.NavbarItem>
      <Styles.NavbarItem>
        <Styles.NavbarLink href="/venda">Venda</Styles.NavbarLink>
      </Styles.NavbarItem>
      <Styles.NavbarItem>
        <Styles.NavbarLink href="/aluguel">Aluguel</Styles.NavbarLink>
      </Styles.NavbarItem>
      <Styles.NavbarItem>
        <Styles.NavbarLink href="/contato">Contato</Styles.NavbarLink>
      </Styles.NavbarItem>
      <Styles.NavbarItem>
        <Styles.NavbarLink
          href={!user || !token ? '/login' : '/area-do-corretor'}>
          Área do corretor
        </Styles.NavbarLink>
      </Styles.NavbarItem>
    </>
  );

  return (
    <Styles.NavbarContainer>
      <Styles.NavbarInner>
        {isMobile && (
          <Styles.MobileMenuButton onClick={toggleMenu}>
            <Menu />
          </Styles.MobileMenuButton>
        )}

        <Styles.NavbarList isMobile={isMobile} isOpen={isMenuOpen}>
          {!isMobile && !isAuthenticated && renderMainMenuItems()}

          {isMobile && isMenuOpen && (
            <Styles.MobileMenu>
              {!isAuthenticated && renderMainMenuItems()}
              {isAuthenticated && <>{renderAgentMenuItems()}</>}
              {!isAuthenticated && (
                <Styles.MobileSearchContainer>
                  <Styles.SearchInput
                    placeholder="Pesquisar..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                  <Styles.IconButton onClick={handleSearch}>
                    <Styles.Icon />
                  </Styles.IconButton>
                </Styles.MobileSearchContainer>
              )}
            </Styles.MobileMenu>
          )}
        </Styles.NavbarList>

        {!isMobile && !isAuthenticated && (
          <Styles.SearchContainer>
            <Styles.SearchInput
              placeholder="Pesquisar..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <Styles.IconButton onClick={handleSearch}>
              <Styles.Icon />
            </Styles.IconButton>
          </Styles.SearchContainer>
        )}
      </Styles.NavbarInner>
    </Styles.NavbarContainer>
  );
};

export default Navbar;
